import store from '@/Redux/store';
import { MESSAGE_HEADER, TOGGLE_CALENDAR, TOGGLE_ERROR_PAGE } from '@/Redux/slices/appSlice';
import { openGlobalSearch, closeGlobalSearch } from '@/Redux/slices/searchSlice';

export const dispatchData = (reducer, data) => {

    switch (reducer) {
        case 'USER':
            store.dispatch(USER(data));
            break;
        case 'MESSAGE_HEADER_OPEN':
            store.dispatch(MESSAGE_HEADER(data));
            break;
        case 'MESSAGE_HEADER_CLOSE':
            store.dispatch(MESSAGE_HEADER(data));
            break;
        case 'TOGGLE_ERROR_PAGE':
            store.dispatch(TOGGLE_ERROR_PAGE(data));
            break;
        case 'TOGGLE_SEARCH':
            store.dispatch(TOGGLE_SEARCH(data));
            break;
        case 'openGlobalSearch':
            store.dispatch(openGlobalSearch());
            break;
        case 'closeGlobalSearch':
            store.dispatch(closeGlobalSearch());
            break;
        default:
            break;
    }
};